export default "__VITE_ASSET__Nyjyu6Dx__"